import React, { useContext, useEffect } from "react";
import Rating from "react-rating";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import CardDiv from "modules/common/card-div/CardDiv";
import { ProgressBar } from "react-bootstrap";
import { Button } from "antd";
import { isEmpty } from "lodash";
import { DownloadOutlined } from "@ant-design/icons";
import { useTicketFeedback } from "./store";
import { FeedbackDate } from "./FeedbackTab";
import xlsx from "json-as-xlsx";
import moment from "moment";
import { maskPhoneNumber } from "modules/utilities/utility";

function TicketFeedbackData({ data, feedbackLength }) {
  const { startDate, endDate } = useContext(FeedbackDate);
  const { fetchTicketFeedbackDownload, ticketDownloadData } =
    useTicketFeedback();

  useEffect(() => {
    fetchTicketFeedbackDownload(startDate.valueOf(), endDate.valueOf());
  }, [startDate]);

  const ExcelDownload = (excelData) => {
    const _data = excelData?.map((el) => {
      return {
        ...el,
        case_id: el.ticket ? el.ticket[0]?.case_id : "",
        order_display_id: el.ticket
          ? el.ticket[0]?.source_meta?.order_display_id
          : "",
        category: el.ticket ? el.ticket[0]?.category : "",
        subCategory: el.ticket ? el.ticket[0]?.sub_category : "",
        userName: el.ticket ? el.ticket[0]?.customer?.first_name : "",
        userPhoneNumber: el.ticket ? maskPhoneNumber(el.ticket[0]?.customer?.phone_number) : "",
        userEmail: el.ticket ? el.ticket[0]?.customer?.email : "",
        currentAssignee: el.ticket
          ? el.ticket[0]?.current_assignment?.first_name
          : "",
        // agentUserId: el.rep ? el.rep?.id : "",
        // updatedAt: moment(el.updatedAt).format("DD-MM-YYYY HH:mm:ss"),
        createdAt: moment(el.createdAt).format("DD-MM-YYYY HH:mm:ss"),
        satisfied: el.satisfied === 0 ? "No" : "Yes",
      };
    });
    const data = [
      {
        sheet: "csatFeedbacks",
        columns: [
          { label: "Case Id", value: "case_id" },
          { label: "Order Id", value: "order_display_id" },
          { label: "Customer Name", value: "userName" },
          { label: "Customer Phone Number", value: "userPhoneNumber" },
          { label: "Customer Email Id", value: "userEmail" },
          { label: "Current Assignee", value: "currentAssignee" },
          { label: "Category", value: "category" },
          { label: "Sub Category", value: "subCategory" },
          {
            label: "Was your query resolved to satisfaction?",
            value: "satisfied",
          },
          {
            label:
              "How would you rate your experience of complaint resolution?",
            value: "experience",
          },
          {
            label: "What did you like about the experience?",
            value: "about_experience",
          },
          {
            label: "What can we improve about the experience?",
            value: "improve_experience",
          },
          {
            label:
              "Would you like to tell us more about your bad experience with our complaint handling process?",
            value: "comment_experience",
          },
          {
            label: "Created At",
            value: "createdAt",
          },
          // {
          // 	label: "Updated At",
          // 	value: "updatedAt",
          // },
        ],
        content: _data,
      },
    ];

    let settings = {
      fileName: `Ticket Feedbacks`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
    };
    xlsx(data, settings);
  };

  return (
    <CardDiv
      title={
        <div className="d-flex justify-content-between align-items-center my-n2">
          <div className="d-flex gap-2">
            <div className="">Experience of complaint resolution</div>
            <div className="d-flex gap-2">
              <div className="fw-bold">Total Count:</div>
              <div className="fw-bold">{feedbackLength}</div>
            </div>
          </div>
          <div>
            <Button
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => ExcelDownload(ticketDownloadData)}
              disabled={isEmpty(ticketDownloadData)}
            >
              Download
            </Button>
          </div>
        </div>
      }
      component={
        <div className="d-flex justify-content-between flex-wrap">
          <div className="w-75 mt-n2">
            {" "}
            <div className="d-flex gap-3">
              <Rating
                initialRating={5}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.experience_5 / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.experience_5}</div>
            </div>
            <div className="d-flex gap-3">
              <Rating
                initialRating={4}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.experience_4 / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.experience_4}</div>
            </div>
            <div className="d-flex gap-3">
              <Rating
                initialRating={3}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.experience_3 / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.experience_3}</div>
            </div>
            <div className="d-flex gap-3">
              <Rating
                initialRating={2}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.experience_2 / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.experience_2}</div>
            </div>
            <div className="d-flex gap-3">
              <Rating
                initialRating={1}
                fullSymbol={
                  <FontAwesomeIcon icon="star" className="text-warning" />
                }
                emptySymbol={
                  <FontAwesomeIcon icon="star" className="text-300" />
                }
                readonly
              />
              <div className="w-50">
                <ProgressBar
                  animated={true}
                  now={(+data?.experience_1 / feedbackLength) * 100}
                />
              </div>
              <div className="fw-bold">{data?.experience_1}</div>
            </div>
          </div>
          <div className="w-25">
            <div className="d-flex flex-row align-items-center gap-2">
              <div className="fs-1">Satisfied :</div>
              <div className="w-50 ms-4">
                <ProgressBar
                  animated={true}
                  now={(+data?.satisfied_1 / feedbackLength) * 100}
                />
              </div>
              <div className="fs-1 fw-bold">{data?.satisfied_1}</div>
            </div>
            <div className="d-flex flex-row gap-2 align-items-center">
              <div className="fs-1">UnSatisfied :</div>
              <div className="w-50 ms-1">
                <ProgressBar
                  animated={true}
                  variant="danger"
                  now={(+data?.satisfied_0 / feedbackLength) * 100}
                />
              </div>
              <div className="fs-1 fw-bold">{data?.satisfied_0}</div>
            </div>
          </div>
        </div>
      }
    />
  );
}

export default TicketFeedbackData;
